"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var inputWrapper_1 = require("../inputWrapper");
var utils_1 = require("../../utils");
var hooks_1 = require("../form/hooks");
var classnames_1 = __importDefault(require("classnames"));
var clickOutside_1 = require("../clickOutside");
var styledLayout_1 = require("../base/styledLayout");
var textbox_1 = require("../textbox");
exports.AutoCompleteBox = React.memo(function (_a) {
    var options = _a.options, name = _a.name, type = _a.type, onlyChildren = _a.onlyChildren, message = _a.message, _b = _a.defaultOption, defaultOption = _b === void 0 ? null : _b, _c = _a.passive, passive = _c === void 0 ? false : _c, _d = _a.size, size = _d === void 0 ? "medium" /* Medium */ : _d, _e = _a.label, label = _e === void 0 ? '' : _e, _f = _a.onSelect, onSelect = _f === void 0 ? utils_1.NOOP : _f, _g = _a.minLength, minLength = _g === void 0 ? 2 : _g, onTextChange = _a.onTextChange;
    var _h = React.useState(false), showOptions = _h[0], toggleShowOptions = _h[1];
    var _j = hooks_1.useForm(defaultOption, name, type, message), selectedOption = _j[0], setSelectedOption = _j[1], _type = _j[2], _message = _j[3];
    var _k = React.useState(options), selectOptions = _k[0], setSelectOptions = _k[1];
    var inputRef = React.useRef({});
    var optionsRef = React.useRef({});
    var autoCompleteBoxClassName = classnames_1.default('ty-autocomplete-box', 'ty-transition', "ty-input-" + size);
    var optionsWrapperClassName = classnames_1.default('ty-autocomplete-box-options', 'ty-scrollbar', 'ty-bordered-focus', { 'ty-on': showOptions });
    var onOptionClick = React.useCallback(function (option, e) {
        var _a;
        e.stopPropagation();
        if ((_a = options) === null || _a === void 0 ? void 0 : _a.some(function (option) { return option.selectedText === option.selectedText; })) {
            toggleShowOptions(!showOptions);
            if (option !== selectedOption) {
                setSelectedOption(option.selectedText);
                if (typeof onSelect === 'function') {
                    onSelect(option);
                }
            }
        }
    }, [showOptions, selectedOption]);
    var _checkSelectBoxOptions = React.useCallback(function (val) {
        if (val === void 0) { val = ''; }
        var _a;
        if (val.length <= minLength) {
            toggleShowOptions(false);
            return;
        }
        var optionsD = (_a = options) === null || _a === void 0 ? void 0 : _a.filter(function (option) {
            var _a, _b, _c, _d;
            var text = (_a = option) === null || _a === void 0 ? void 0 : _a.selectedText;
            if ((_b = option) === null || _b === void 0 ? void 0 : _b.filterValue) {
                text = (_c = option) === null || _c === void 0 ? void 0 : _c.filterValue;
            }
            return ((_d = text) === null || _d === void 0 ? void 0 : _d.toLocaleLowerCase().indexOf(val.toLocaleLowerCase())) > -1;
        });
        setSelectOptions(optionsD);
        if (options.length > 0) {
            toggleShowOptions(true);
        }
        else {
            toggleShowOptions(false);
        }
    }, [showOptions, selectOptions]);
    var handleTextChange = React.useCallback(function (val) {
        _checkSelectBoxOptions(val);
        if (onTextChange) {
            onTextChange(val);
        }
    }, [showOptions, selectOptions]);
    var handleSelectOnClick = React.useCallback(function () {
        if (inputRef.current) {
            var val = inputRef.current.value;
            _checkSelectBoxOptions(val);
        }
    }, [showOptions]);
    React.useEffect(function () {
        setSelectedOption(defaultOption);
    }, [options]);
    return (React.createElement(inputWrapper_1.InputWrapper, { passive: passive, type: _type, message: _message, label: label, size: size, onlyChildren: onlyChildren },
        React.createElement(clickOutside_1.ClickOutside, { onClickOutside: function () { return toggleShowOptions(false); }, condition: !passive },
            React.createElement(styledLayout_1.StyledLayout, { display: "ty-display-flex" /* Flex */, position: "ty-relative" /* Relative */, onClick: handleSelectOnClick, className: autoCompleteBoxClassName, tabIndex: "-1" },
                React.createElement(textbox_1.Textbox, { name: name, onChange: handleTextChange, forwardedRef: inputRef, size: size }),
                React.createElement(styledLayout_1.StyledLayout, { forwardedRef: optionsRef, position: "ty-absolute" /* Absolute */, display: "ty-display-flex" /* Flex */, flexDirection: "ty-flex-column" /* Column */, className: optionsWrapperClassName, tabIndex: passive ? '-1' : '0' }, selectOptions.map(function (option, index) {
                    var key = "autocomplete-box-option-" + label + "-" + index;
                    return (React.createElement("div", { className: "ty-autocomplete-box-option", key: key, onClick: function (e) { return onOptionClick(option, e); } }, option.visual));
                }))))));
});
